var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarTimesheet(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3875 7.19375C12.3875 6.72776 12.0098 6.35 11.5438 6.35C11.0778 6.35 10.7 6.72776 10.7 7.19375V11.5438C10.7 12.0097 11.0778 12.3875 11.5438 12.3875H14.8063C15.2723 12.3875 15.65 12.0097 15.65 11.5438C15.65 11.0778 15.2723 10.7 14.8063 10.7H12.3875V7.19375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C8.61305 2 6.32387 2.94821 4.63604 4.63604C2.94821 6.32387 2 8.61305 2 11C2 13.3869 2.94821 15.6761 4.63604 17.364C6.32387 19.0518 8.61305 20 11 20C13.3869 20 15.6761 19.0518 17.364 17.364C19.0518 15.6761 20 13.3869 20 11C20 8.61305 19.0518 6.32387 17.364 4.63604C15.6761 2.94821 13.3869 2 11 2ZM5.82928 5.82928C7.20064 4.45792 9.0606 3.6875 11 3.6875C12.9394 3.6875 14.7994 4.45792 16.1707 5.82928C17.5421 7.20064 18.3125 9.0606 18.3125 11C18.3125 12.9394 17.5421 14.7994 16.1707 16.1707C14.7994 17.5421 12.9394 18.3125 11 18.3125C9.0606 18.3125 7.20064 17.5421 5.82928 16.1707C4.45792 14.7994 3.6875 12.9394 3.6875 11C3.6875 9.0606 4.45792 7.20064 5.82928 5.82928Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTimesheet);
export default __webpack_public_path__ + "static/media/sidebar-timesheet.21972ab0.svg";
export { ForwardRef as ReactComponent };